var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sr-square-block"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16406 1.66667C2.78335 1.66667 1.66406 2.78595 1.66406 4.16667V6.66667C1.66406 8.04738 2.78335 9.16667 4.16406 9.16667H6.66406C8.04477 9.16667 9.16406 8.04738 9.16406 6.66667V4.16667C9.16406 2.78595 8.04478 1.66667 6.66406 1.66667H4.16406ZM3.33073 4.16667C3.33073 3.70643 3.70383 3.33333 4.16406 3.33333H6.66406C7.1243 3.33333 7.4974 3.70643 7.4974 4.16667V6.66667C7.4974 7.1269 7.1243 7.5 6.66406 7.5H4.16406C3.70383 7.5 3.33073 7.1269 3.33073 6.66667V4.16667Z",
    fill: "#2D3740"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3307 1.66667C11.95 1.66667 10.8307 2.78595 10.8307 4.16667V6.66667C10.8307 8.04738 11.95 9.16667 13.3307 9.16667H15.8307C17.2114 9.16667 18.3307 8.04738 18.3307 6.66667V4.16667C18.3307 2.78595 17.2114 1.66667 15.8307 1.66667H13.3307ZM12.4974 4.16667C12.4974 3.70643 12.8705 3.33333 13.3307 3.33333H15.8307C16.291 3.33333 16.6641 3.70643 16.6641 4.16667V6.66667C16.6641 7.1269 16.291 7.5 15.8307 7.5H13.3307C12.8705 7.5 12.4974 7.1269 12.4974 6.66667V4.16667Z",
    fill: "#2D3740"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66406 13.3333C1.66406 11.9526 2.78335 10.8333 4.16406 10.8333H6.66406C8.04478 10.8333 9.16406 11.9526 9.16406 13.3333V15.8333C9.16406 17.214 8.04477 18.3333 6.66406 18.3333H4.16406C2.78335 18.3333 1.66406 17.214 1.66406 15.8333V13.3333ZM4.16406 12.5C3.70383 12.5 3.33073 12.8731 3.33073 13.3333V15.8333C3.33073 16.2936 3.70383 16.6667 4.16406 16.6667H6.66406C7.1243 16.6667 7.4974 16.2936 7.4974 15.8333V13.3333C7.4974 12.8731 7.1243 12.5 6.66406 12.5H4.16406Z",
    fill: "#2D3740"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3307 10.8333C11.95 10.8333 10.8307 11.9526 10.8307 13.3333V15.8333C10.8307 17.214 11.95 18.3333 13.3307 18.3333H15.8307C17.2114 18.3333 18.3307 17.214 18.3307 15.8333V13.3333C18.3307 11.9526 17.2114 10.8333 15.8307 10.8333H13.3307ZM12.4974 13.3333C12.4974 12.8731 12.8705 12.5 13.3307 12.5H15.8307C16.291 12.5 16.6641 12.8731 16.6641 13.3333V15.8333C16.6641 16.2936 16.291 16.6667 15.8307 16.6667H13.3307C12.8705 16.6667 12.4974 16.2936 12.4974 15.8333V13.3333Z",
    fill: "#2D3740"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f90a689b220ff6b3d8a3f692a4b7f129.svg";
export { ForwardRef as ReactComponent };